import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from 'semantic-ui-react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { selectCurrentUserId, selectCurrentUserName, userLoggedOut } from "../slices/currentUser/currentUserSlice";
import server_config from '../ServerConfiguration';
const fevir_website_address = server_config["fevir_website_address"];

const onLogoutClicked = async (dispatch) => {
    await firebase.auth().signOut().then(async () => {
        console.log("Signing out...");
        dispatch(userLoggedOut());
    }).catch((error) => { console.log(error); });
}

const Navbar = ({ userLoadingState }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.substring(1)
    const user = useSelector(selectCurrentUserId)
    const userName = useSelector(selectCurrentUserName)
    const isLoggedIn = !!user

    let subpageClass = "";
    if (path) {
        subpageClass = "navbarSubPage";
    }

    return <div id="navbar" name="navbar" className={"navbar " + path + " " + subpageClass}>
        <Link to="" className="navbar-logo-container">
            <img id="navbarlogo" className="navbar-logo navbar-logo-wide" alt="Computable Publishing logo" src="/png-01-wide-tiny.png" />
            <img className="navbar-logo navbar-logo-small" alt="Computable Publishing logo" src="/cplogo-192.png"/>
        </Link>
        <div id="navbarPageLinks" className="right-justify navbar-page-links">
            <Link to="/mission" className={path === "mission" ? "selectedNavbarSubPage" : ""}>Making Science Computable</Link>
            <Link to="/products" className={path === "products" ? "selectedNavbarSubPage" : ""}>Products</Link>
            <Link to="/media" className={path === "media" ? "selectedNavbarSubPage" : ""}>Presentations</Link>
            <Link to="/about" className={path === "about" ? "selectedNavbarSubPage" : ""}>Team</Link>
            {isLoggedIn ? <>
                <Link to={'https://fevir.net/editprofile'} >
                    <span style={{ fontSize: '20px' }}>{userName || "Edit User Profile"}</span>
                </Link>
                <span><Button className="formButton logOutLogInButton" style={{ marginLeft: "4px" }}
                    content="Log Out" compact onClick={() => { onLogoutClicked(dispatch) }} /></span>
            </>
                :
                <>
                    <span><Button disabled={userLoadingState} className="formButton logOutLogInButton"
                        content="Sign In / Create Account" compact
                        onClick={() => {
                            let fevirSsoAddress = fevir_website_address + "/noheader/sso?redirect=" + encodeURIComponent(window.location.origin + window.location.pathname);
                            window.location.assign(fevirSsoAddress);
                        }} /></span>
                    {/* <span><Spinner height={20} /></span> */}
                </>}
        </div>
    </div>;
}

export default Navbar;